import { fetchAuthSession, signOut } from 'aws-amplify/auth';
import { OpenAPI } from '../generated-api';

/**
 * Token resolver function for OpenAPI client
 * This function is called by the generated API client to get the current auth token
 */
const getAuthToken = async (): Promise<string> => {
  try {
    const session = await fetchAuthSession();
    const token = session.tokens?.idToken?.toString();
    if (!token) {
      throw new Error('No auth token available');
    }
    return token;
  } catch (error) {
    console.log('No authenticated user:', error);
    throw error;
  }
};

// Track if auth has been initialized to avoid duplicate messages
let isAuthInitialized = false;

/**
 * Initialize the OpenAPI client with authentication
 * This should be called once when the app starts
 */
export const initializeAuth = (): void => {
  // Set the token resolver function
  OpenAPI.TOKEN = getAuthToken;

  if (!isAuthInitialized) {
    console.log('OpenAPI authentication initialized');
    isAuthInitialized = true;
  }
};

export const initializeSession = async (): Promise<any> => {
  const token = await getAuthToken();
  // Use DOCKER_BACKEND_URL in local development, otherwise use API_URL
  const apiUrl = process.env.REACT_APP_DOCKER_BACKEND_URL || process.env.REACT_APP_API_URL;

  const response = await fetch(`${apiUrl}/session/initialize`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('Failed to initialize session');
  }

  return response.json();
};

/**
 * Handle authentication errors by signing out and redirecting
 */
export const handleAuthError = async (): Promise<void> => {
  try {
    await signOut();
  } catch (error) {
    console.error('Error signing out:', error);
  }
  // Redirect to login page
  window.location.href = '/login';
};

/**
 * Check if user is authenticated without throwing errors
 */
export const isAuthenticated = async (): Promise<boolean> => {
  try {
    const session = await fetchAuthSession();
    return !!(session.tokens?.idToken);
  } catch (error) {
    return false;
  }
};